var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgArrowRightCircle = function SvgArrowRightCircle(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.146 9.646a.5.5 0 0 1 .708 0L16.207 12l-2.353 2.354a.5.5 0 0 1-.708-.708l1.147-1.146H8v-1h6.293l-1.147-1.146a.5.5 0 0 1 0-.708"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M12 22c5.523 0 10-4.477 10-10S17.523 2 12 2 2 6.477 2 12s4.477 10 10 10m0-1a9 9 0 1 0 0-18 9 9 0 0 0 0 18",
    clipRule: "evenodd"
  })));
};
export default SvgArrowRightCircle;